import React from 'react';
import { Table } from 'reactstrap';
import Logger from "../../common/Logger";
import { setProperty } from "../../types/Model";
import { RatingMeasureProps, RatingScale, RatingScaleItem } from '../../types/RatingMeasure';
import ColorPicker from '../control/ColorPicker';
import ContextMenuBase from '../control/ContextMenuBase';
import Editable from '../control/Editable';

const logger = new Logger("rating.RatingScaleEditor");

function RatingScaleEditor(props:any) {
  const ratingScale:RatingScale = props.ratingScale;
  const onChange = props.onChange;

  logger.debug("Rendering:", ratingScale);

  return (
    <Table>
      <thead className="thead-light">
        <tr>
          <th>Value</th>
          <th>Name</th>
          <th>Description</th>
          <th>Color</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        { ratingScale && ratingScale.scale.map((scaleItem:RatingScaleItem,index) =>
          <tr key={scaleItem.value}>
            <td><Editable item={scaleItem} property={RatingMeasureProps.value} onChange={onChangeScaleItem} numeric={true} /></td>
            <td className="text-nowrap"><Editable item={scaleItem} property={RatingMeasureProps.Name} onChange={onChangeScaleItem} /></td>
            <td className="text-nowrap pe-3"><Editable item={scaleItem} property={RatingMeasureProps.description} onChange={onChangeScaleItem} /></td>
            <td className="align-middle"><ColorPicker item={scaleItem} property={RatingMeasureProps.color} onChange={onChangeScaleItem} /></td>
            <td className="rowmenu">
              <ContextMenu item={scaleItem} index={index} />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );

  function onChangeScaleItem(scaleItem:RatingScaleItem, property:keyof RatingScaleItem, newValue:any) {
    try {
      logger.debug("onChangeScaleItem: property=%s, value=", property, newValue, scaleItem);

      if (scaleItem !== undefined) {
        setProperty(scaleItem, property, newValue);
        onChange(ratingScale);
      }
    } catch (e) {
      logger.error("onChangeScaleItem: Exception caught:", e);
      alert(e);
    }
  }

  function onAddScaleItem(scaleItem:RatingScaleItem, index:number) {
    logger.debug("onAddScaleItem: index=%s, scaleItem=", index, scaleItem);
    ratingScale.scale.splice(index+1, 0, scaleItem);
    onChange(ratingScale);
  }

  function onDeleteScaleItem(scaleItem:RatingScaleItem, index:number) {
    logger.debug("onDeleteScaleItem: index=%s, scaleItem=", index, scaleItem);
    ratingScale.scale.splice(index, 1);
    onChange(ratingScale);
  }

  function ContextMenu(props:any) {
    const scaleItem:RatingScaleItem = props.item;
    const index:number = props.index;

    return (
      <ContextMenuBase logger="rating.RatingScaleEditor.ContextMenu">
        <button className="btn-image" onClick={() => onAddScaleItem(scaleItem, index)}>
          <i className="far fa-plus"></i>
        </button>
        <button className="btn-image ps-1 pe-1" onClick={() => onDeleteScaleItem(scaleItem, index)}>
          <i className="far fa-trash-alt"></i>
        </button>
      </ContextMenuBase>
    );
  }
}

export default RatingScaleEditor;
